import { ReviewStatus } from '../../constants';

export type Review = {
  productId: number;
  reviewId: number;
  name: string;
  email: string;
  rating: number;
  body: string;
  title: string;
  pictureUrls: string[];
  skinType: string[];
  skinConcern: string[];
  status: ReviewStatus;
  modifiedAt: string;
};
export type ProductStatistic = {
  productId: number;
  averageRate: number;
  totalReviews: number;
};
